<div class="container">
  <h3 class="text-primary ab_left_text">SERVICE UTILITY MANAGER
  </h3>
  <blockquote class="generic-blockquote">
    Compliance Planet includes amongst it’s features a service manager from which designated persons can carry out
    first hand technical support. E.g restart, deactivation, activation of compliance planet artificial intelligence
    services. This feature also includes service logs from which all operations of the software can be monitored and
    provides report for secondary technical support as may be required.
  </blockquote>
</div>